import React, { useEffect, useState } from 'react';
import { Card, Button, Typography, Row, Col, Radio, Input, Space, Spin } from 'antd';
import { SearchOutlined, ArrowRightOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Title, Paragraph, Text } = Typography;

const FILTER_TAGS = [
    'Tümü',
    '4. 5. 6. 7. 8. Sınıf',
    '9. 10. ve 11. Sınıf',
    'YKS',
    'AYT',
    'TYT',
    'LGS',
    'KPSS',
    'KONULAR',
];

const DEFAULT_IMAGE = '/img/course-cover.svg';
const CHECK_ICON = '/img/CheckCircleDark.svg';

interface Course {
    id: number;
    imageUrl?: string;
    name: string;
    description: string;
    subhead: string;
    salePrice: number;
    listPrice: number;
    tags: string;
    subjects?: any[];
    totalVideo?: number;
    totalDocument?: number;
    totalQuestion?: number;
}

const WebCourseList: React.FC = () => {
    const [courses, setCourses] = useState<Course[]>([]);
    const [filteredCourses, setFilteredCourses] = useState<Course[]>([]);
    const [filterTag, setFilterTag] = useState<string>('Tümü');
    const [searchMode, setSearchMode] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        fetchCourses();
    }, []);

    useEffect(() => {
        filterCourses();
        // eslint-disable-next-line
    }, [filterTag, searchTerm, courses]);

    async function fetchCourses() {
        setLoading(true);
        try {
            const res = await axios.get<Course[]>('https://api.sahadabasari.com/api/v1/website/course');
            setCourses(res.data);
        } catch (e) {
            // Hata yönetimi burada
        }
        setLoading(false);
    }

    function filterCourses() {
        let filtered: Course[] = [...courses];

        if (searchMode && searchTerm.length >= 3) {
            filtered = filtered.filter((c: Course) =>
                c.tags?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        } else if (!searchMode || searchTerm.length < 3) {
            if (filterTag === 'Tümü') {
                // hepsini göster
            } else if (filterTag === '9. 10. ve 11. Sınıf') {
                filtered = filtered.filter((c: Course) => {
                    const tags = c.tags?.toLowerCase();
                    return (
                        tags.includes('9.sınıf') ||
                        tags.includes('10.sınıf') ||
                        tags.includes('11.sınıf')
                    );
                });
            } else if (filterTag === '4. 5. 6. 7. 8. Sınıf') {
                filtered = filtered.filter((c: Course) => {
                    const tags = c.tags?.toLowerCase();
                    return (
                        tags.includes('4.sınıf') ||
                        tags.includes('5.sınıf') ||
                        tags.includes('6.sınıf') ||
                        tags.includes('7.sınıf') ||
                        tags.includes('8.sınıf')
                    );
                });
            } else {
                filtered = filtered.filter((c: Course) =>
                    c.tags?.toLowerCase().includes(filterTag.toLowerCase())
                );
            }
        }

        setFilteredCourses(filtered);
    }

    return (
        <div style={{ background: 'linear-gradient(180deg, #924CBB 0%, #44287C 100%)', minHeight: '100vh', padding: 32 }}>
            <div style={{ maxWidth: 1280, margin: '0 auto' }}>
                <Title style={{ color: '#fff', marginBottom: 32, textAlign: 'center' }}>
                    Size en uygun planı seçin.
                </Title>

                <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 24 }}>
                    <Col flex="auto">
                        {!searchMode ? (
                            <Radio.Group
                                optionType="button"
                                buttonStyle="solid"
                                value={filterTag}
                                onChange={(e) => setFilterTag(e.target.value)}
                                style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 16, padding: 8 }}
                            >
                                {FILTER_TAGS.map((tag: string) => (
                                    <Radio.Button
                                        key={tag}
                                        value={tag}
                                        style={{
                                            color: '#fff',
                                            background: filterTag === tag ? '#6C38C6' : 'transparent',
                                            border: 0,
                                        }}
                                    >
                                        {tag}
                                    </Radio.Button>
                                ))}
                            </Radio.Group>
                        ) : (
                            <Input
                                size="large"
                                autoFocus
                                allowClear
                                placeholder="Etiket ile ara..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ maxWidth: 320, background: 'rgba(255,255,255,0.96)' }}
                            />
                        )}
                    </Col>
                    <Col flex="64px">
                        <Button
                            shape="circle"
                            size="large"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                setSearchMode(!searchMode);
                                setSearchTerm('');
                            }}
                            style={{ background: '#6C38C6', color: '#fff', border: 0 }}
                        />
                    </Col>
                </Row>

                <Spin spinning={loading}>
                    <Row gutter={[24, 32]}>
                        {filteredCourses.map((course: Course) => (
                            <Col key={course.id} xs={24} sm={12} md={8} lg={6}>
                                <Card
                                    hoverable
                                    style={{
                                        borderRadius: 24,
                                        minHeight: 410,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        boxShadow: '0 2px 12px 0 rgba(60,36,102,.14)',
                                        marginBottom: 8,
                                    }}
                                    cover={
                                        <div style={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, overflow: 'hidden' }}>
                                            <img
                                                src={course.imageUrl || DEFAULT_IMAGE}
                                                alt={course.name}
                                                width="100%"
                                                height="180"
                                                style={{ objectFit: 'cover', display: 'block' }}
                                            />
                                        </div>
                                    }
                                    bodyStyle={{ padding: 18, flexGrow: 1, display: 'flex', flexDirection: 'column' }}
                                >
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                                        <Title level={5} style={{ marginBottom: 12 }}>{course.name}</Title>
                                        <Space size="small" style={{ marginBottom: 12 }}>
                                            <Text strong style={{ fontSize: 20 }}>{course.salePrice?.toLocaleString('tr-TR')} ₺</Text>
                                            <Text delete type="secondary" style={{ fontSize: 16 }}>{course.listPrice?.toLocaleString('tr-TR')} ₺</Text>
                                        </Space>
                                        <Paragraph style={{ marginBottom: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: course.subhead }} />
                                        </Paragraph>
                                        <Space direction="vertical" size={6} style={{ marginBottom: 12 }}>
                                            {course.description?.split('\n').map((item: string, idx: number) => (
                                                <Text key={idx} type="secondary" style={{ fontSize: 14 }}>• {item}</Text>
                                            ))}
                                            <Text style={{ display: 'flex', alignItems: 'center', fontSize: 15 }}>
                                                <img src={CHECK_ICON} width={24} height={24} alt="check" style={{ marginRight: 6 }} />
                                                Velilere Özel Gelişim Bilgilendirme Sistemi
                                            </Text>
                                        </Space>
                                    </div>
                                    <Space style={{ width: '100%', marginTop: 12 }} size="middle">
                                        <Button
                                            type="default"
                                            style={{
                                                width: '50%',
                                                borderRadius: 16,
                                                background: '#6c38c6',
                                                color: '#fff',
                                                border: 'none',
                                                fontWeight: 600,
                                            }}
                                            href={`https://www.sahadabasari.com/paket/8sinif${course.id}`}
                                        >
                                            Detay <ArrowRightOutlined />
                                        </Button>
                                        <Button
                                            type="primary"
                                            style={{
                                                width: '50%',
                                                borderRadius: 16,
                                                fontWeight: 600,
                                            }}
                                            href={`https://app.sahadabasari.com/kaydol?course=${course.id}`}
                                            target="_blank"
                                        >
                                            Satın Al
                                        </Button>
                                    </Space>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Spin>
            </div>
        </div>
    );
};

export default WebCourseList;
